import { render, staticRenderFns } from "./SwichPayIn.vue?vue&type=template&id=55cc287e&scoped=true&"
import script from "./SwichPayIn.vue?vue&type=script&lang=js&"
export * from "./SwichPayIn.vue?vue&type=script&lang=js&"
import style0 from "./SwichPayIn.vue?vue&type=style&index=0&id=55cc287e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cc287e",
  null
  
)

export default component.exports